<section class="tenant-dashboard">
  <app-card variant="default" padding="none" class="tenants-table-card table-card">

<div *ngIf="loading" class="loading-container">
        <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
        <p>Loading tenants...</p>
      </div>

      <div *ngIf="!loading && tenants.length === 0" class="empty-state">
        <div class="empty-state__icon">
          <mat-icon>business</mat-icon>
        </div>
        <h3>No tenants yet</h3>
        <p>Create your first tenant organization to get started.</p>
        <button mat-flat-button color="primary" (click)="onCreateTenant()" *appHasPermission="'tenant.create'">
          <mat-icon>add</mat-icon>
          Create First Tenant
        </button>
      </div>

      <div *ngIf="!loading && tenants.length > 0" class="table-container">
        <table mat-table [dataSource]="tenants" class="modern-table">
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Organization</th>
            <td mat-cell *matCellDef="let tenant">
              <div class="tenant-cell">
                <div class="tenant-cell__icon">
                  <mat-icon>business</mat-icon>
                </div>
                <div class="tenant-cell__info">
                  <span class="tenant-cell__name">{{ tenant.name }}</span>
                  <span class="tenant-cell__type" *ngIf="tenant.business_type">{{ tenant.business_type
                    }}</span>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Business Type Column -->
          <ng-container matColumnDef="business_type">
            <th mat-header-cell *matHeaderCellDef>Business Type</th>
            <td mat-cell *matCellDef="let tenant">
              <span class="badge">{{ tenant.business_type || 'General' }}</span>
            </td>
          </ng-container>

          <!-- Country Column -->
          <ng-container matColumnDef="country">
            <th mat-header-cell *matHeaderCellDef>Country</th>
            <td mat-cell *matCellDef="let tenant">
              {{ tenant.country || '—' }}
            </td>
          </ng-container>

          <!-- Resources Column -->
          <ng-container matColumnDef="resources">
            <th mat-header-cell *matHeaderCellDef>Resources</th>
            <td mat-cell *matCellDef="let tenant">
              <div class="resource-badges">
                <span class="resource-badge resource-badge--sites">
                  <mat-icon>store</mat-icon>
                  {{ tenant.sites_count || 0 }}
                </span>
                <span class="resource-badge resource-badge--users">
                  <mat-icon>people</mat-icon>
                  {{ tenant.users_count || 0 }}
                </span>
              </div>
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let tenant">
              <span class="status-badge" [class.active]="tenant.is_active"
                [class.inactive]="!tenant.is_active">
                <span class="status-indicator"></span>
                {{ tenant.is_active ? 'Active' : 'Inactive' }}
              </span>
            </td>
          </ng-container>

          <!-- Created At Column -->
          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef>Created</th>
            <td mat-cell *matCellDef="let tenant">
              {{ formatDate(tenant.created_at) }}
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let tenant">
              <div class="action-buttons">
                <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="More actions">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="onViewTenant(tenant)" *appHasPermission="'tenant.read'">
                    <mat-icon>visibility</mat-icon>
                    <span>View Details</span>
                  </button>
                  <mat-divider></mat-divider>
                  <button mat-menu-item (click)="onEditTenant(tenant)" *appHasPermission="'tenant.update'">
                    <mat-icon>edit</mat-icon>
                    <span>Edit</span>
                  </button>
                  <button mat-menu-item (click)="onToggleActive(tenant)" *appHasPermission="'tenant.update'">
                    <mat-icon>{{ tenant.is_active ? 'block' : 'check_circle' }}</mat-icon>
                    <span>{{ tenant.is_active ? 'Deactivate' : 'Activate' }}</span>
                  </button>
                  <mat-divider></mat-divider>
                  <button mat-menu-item (click)="onDeleteTenant(tenant)" class="danger-item"
                    *appHasPermission="'tenant.delete'">
                    <mat-icon>delete</mat-icon>
                    <span>Delete</span>
                  </button>
                </mat-menu>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
        </table>

        <mat-paginator
          [length]="total"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [pageSizeOptions]="pageSizeOptions"
          [showFirstLastButtons]="true"
          aria-label="Tenant pagination"
          (page)="handlePageEvent($event)"
        ></mat-paginator>
      </div>
  </app-card>
</section>